// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"JoinPageModal_iconWrapper__wlkTY","content":"JoinPageModal_content__q0cIr","body":"JoinPageModal_body__ZmpAF","footer":"JoinPageModal_footer__ZYl6z"};